export default __webpack_public_path__ + "static/media/about.e4662ca9.jpg";